import React, {Fragment} from 'react'
import {useOutletContext, useRouteLoaderData} from '@remix-run/react'
import {useReportWidgetSeen} from '~/hooks/analytic-hooks'
import {getTranslation} from '~/localization/translation'
import type {RootAndListContext, RootLoaderResponse} from '~/types'
import {LastPurchasedIndicatorIcon} from '~/icons/last-purchased-indicator-icon'
import {FlagIconByLocale} from '~/icons/flag-icons-by-locale'
import {FlagIconsUS} from '~/icons/flag-icons-us'

const LastPurchases = () => {
  const {language, locale, isUSLocale} = useRouteLoaderData('root') as RootLoaderResponse
  const {
    dataResponse: {lastPurchasesData},
  } = useOutletContext<RootAndListContext>()
  const translations = getTranslation(language)

  const [widgetRef] = useReportWidgetSeen({
    widget_name: 'last-purchased-section',
    widget_place: 'middle',
  })

  return (
    <div className="flex flex-col gap-3" ref={widgetRef}>
      <div className="flex flex-row justify-between rounded-xl border bg-white p-4 text-center text-base font-medium shadow tablet:flex-col tablet:gap-y-4">
        <div className="mb-auto flex w-full flex-row items-center gap-2 text-xl font-normal">
          <LastPurchasedIndicatorIcon />
          {translations.Badge.lastPurchases}
        </div>
        <div className="flex w-full flex-col gap-2">
          {lastPurchasesData?.map((p) => (
            <Fragment key={`${p.id}-${p.name}`}>
              <div className="flex flex-row justify-between tablet:gap-x-2">
                <span className="w-full text-start text-base font-light text-gray-900 desktop:flex-1 tablet:w-1/3">
                  {p.name}
                </span>
                <div className="flex w-full flex-1 flex-row justify-between">
                  <div className="flex flex-row items-center gap-2 text-base font-light text-gray-900">
                    {isUSLocale ? (
                      <FlagIconsUS />
                    ) : (
                      <FlagIconByLocale locale={locale} className="[&>g>g>.border-flag]:!stroke-none" />
                    )}
                    {p.city}
                  </div>
                  <span className="text-base font-light text-gray-500">{p.formatedDateString}</span>
                </div>
              </div>
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  )
}

export default LastPurchases
